module.exports = {
    "Clear search": `Clear search`
};


//# sourceMappingURL=en-US.main.js.map
